import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { CategoryService } from '../../../core/services/category.service';
// import { browserRefresh } from 'src/app/app.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  @Input() categoryList: any;
  @Input() categoryArabicList: any;
  @Input() selectedCategory: any;
  @Input() assessmentDetails: any;
  @Input() progressCountState: any;
  @Output() changeCategory: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();
  //  public browserRefresh!: boolean;
  targetDate: any;
  currentRoute: any;
  isArabic!: boolean;
  totalQns: any;
  qnsComplete: any;
  qnsComplete2: any;
  subscription: any;
  subscriptionEvent: any;
  isResubmit: any;
  questionnaireType: any;
  subscriptionRefresh: any;
  isChecker!: any;
  isMakerCheckerEnabled!: any;
  isView: any;
  assessmentProgressPercentage: number = 0;
  totalAns: any = 0;
  userDetails!: any;
  questionnaireAccountGuid!: any;
  questionaireguid!: any;

  constructor(private route: Router, private categoryService: CategoryService, private storageService: StorageService,
    private assessmentService: AssessmentService, private commonService: CommonService, private activateRoute: ActivatedRoute) {
    this.subscription = this.activateRoute.queryParams.subscribe((queryParam: any) => {
      if (queryParam.hasOwnProperty('questionnairetype')) {
        this.questionnaireType = queryParam.questionnairetype;
        if (queryParam.hasOwnProperty('action') && queryParam.action == 'resubmit') {
          this.isResubmit = true;
          this.isView = false;
        } else if (queryParam.hasOwnProperty('action') && queryParam.action == 'view') {
          this.isResubmit = false;
          this.isView = true;
        } else {
          this.isResubmit = false;
          this.isView = false;
        }
      }
    });

  }

  ngOnInit(): void {
    // this.browserRefresh = browserRefresh;
    // console.log("getting assessmentDetails : ", this.assessmentDetails);
    this.totalQns = this.storageService.getSessionStorageData('totalQues');
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.questionnaireAccountGuid = this.assessmentDetails.questionnaireAccountGuid;
    this.questionaireguid = this.assessmentDetails.questionnaireguid;
    // if (this.assessmentDetails?.targetDate) {
    //   const dt = new Date(this.assessmentDetails?.targetDate);
    //   this.targetDate = dt.getDate() + '/' + (dt.getMonth() + 1) + '/' + dt.getFullYear();
    //   // console.log("date ",dt.getDate())
    //   // console.log("month ",dt.getMonth())
    //   // console.log("year ",dt.getFullYear())

    //   // console.log(this.targetDate);
    // }
    if (this.assessmentDetails?.targetDate) {
      const datePart = this.assessmentDetails.targetDate.split('T')[0];   
      const [year, month, day] = datePart.split('-'); 
      this.targetDate = `${Number(day)}/${Number(month)}/${year}`;
    }
    // if (!this.isResubmit) {
    if (this.assessmentDetails.questionnaireProgress || this.assessmentDetails.questionnaireProgress == 0) {

      this.assessmentDetails.questionnaireProgress = this.storageService.getSessionStorageData('quesStatus');
      this.categoryService.setProgressStatus(this.assessmentDetails?.questionnaireProgress);

      //console.log('localstorage val: ', this.storageService.getSessionStorageData('quesStatus'));
      this.categoryService.progressStatusValue$.subscribe((value) => {
        this.assessmentDetails.questionnaireProgress = value;
        this.storageService.setSessionStorageData('quesStatus', this.assessmentDetails?.questionnaireProgress);
      });
    }

    if (this.assessmentDetails.answeredCount || this.assessmentDetails.answeredCount == 0) {
      this.assessmentDetails.answeredCount = this.storageService.getSessionStorageData('answeredQues');
      //assessmentProgressChange
      this.categoryService.setCountOfAnswered(this.assessmentDetails?.answeredCount);
      this.categoryService.setAssessmentProgressChange(true);

      //console.log('localstorage val answeredCount: ', this.storageService.getSessionStorageData('answeredQues'));
      //assessmentProgressChange
      this.categoryService.answeredCount$.subscribe((value) => {
        //overriding value and fetching from api instead

        if (value <= this.totalQns) {
          //commenting as of now
          this.assessmentDetails.answeredCount = value;
        } else {
          this.assessmentDetails.answeredCount = this.totalQns;
        }
        if (this.isArabic) {
                    console.log("lsjfdldsf")

          this.qnsComplete = `${this.assessmentDetails.answeredCount} من أصل ${this.totalQns} أسئلة`;
        } else {
          this.qnsComplete = `${this.assessmentDetails.answeredCount} Out of ${this.totalQns} Questions`;
        }
        this.storageService.setSessionStorageData('answeredQues', this.assessmentDetails?.answeredCount);
      });
    }
    this.subscribeCategoryEvent();

    //}
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes.hasOwnProperty('progressCountState')) {
      // this.generateCountOfEacTypeQues();
      this.totalAns = this.progressCountState?.totalAnswers ? this.progressCountState?.totalAnswers : 0;
      let outOf=this.isArabic?'من أصل':'Out of'
            this.qnsComplete2 = `${this.totalAns} ${outOf} ${this.totalQns} Questions`;
      if (this.isChecker) {
        this.totalAns = this.progressCountState?.totalReviewedAnswers ? this.progressCountState?.totalReviewedAnswers : 0;
        this.qnsComplete2 = `${this.totalAns} ${outOf} ${this.totalQns} Questions`;
      }
      this.calculateProgressStatus();
    }
  }
   lastSavedProgress: number = -1;
   calculateProgressStatus() {
    if (this.totalAns > 0 && Number(this.totalQns) > 0) {
      let basicPercentage = this.totalAns / Number(this.totalQns);
      let decimalValue = this.calculateDecimalValue(basicPercentage);
      let progress = decimalValue * 100;
      progress = Math.min(Math.max(progress, 0), 100);

      // Only update if new progress is meaningfully different
      if (Math.abs(progress - this.lastSavedProgress) >= 0.01) {
        this.assessmentProgressPercentage = progress;
        this.lastSavedProgress = progress;
        this.updateQuestionnaireProgress();
      } else {
        // Optional: skip update, log if needed
        // console.log(`Skipping updateProgress, value unchanged: ${progress}`);
      }
    }
}

  calculateDecimalValue(basicPercentage: any) {

    let strPercent = basicPercentage.toString();
    let arrPercent = strPercent.split('.');
    let final;
    if (arrPercent[1]) {
      //final = arrPercent[0] + '.' + arrPercent[1]?.substring(0, 2);
      final = arrPercent[0] + '.' + arrPercent[1]?.substring(0, 5);
    } else {
      final = arrPercent[0];
    }
    return Number(final);
  }

  subscribeCategoryEvent() {
    this.subscriptionEvent = this.categoryService.isCategoryChange$.subscribe((data) => {
      //console.log('category change: ', data);
      if (data) {
        let index = this.categoryList?.findIndex((ele: any) => ele === this.selectedCategory);
        if (index < (this.categoryList.length - 1)) {
          this.selectedCategory = this.categoryList[index + 1];
          this.loadCategory(this.selectedCategory);
        } else if (index !== -1) {
          //if (!this.isResubmit) {
          this.changeTab.emit(true);
          //}
        }
      }
    });
  }

  loadCategory(category: string): void {
    //if (!this.isResubmit) {
    window.scrollTo(0, 0);
    this.changeCategory.emit(category);
    //}
  }

  goToProgressTracker() {
    let rqstBody = {
      questionnaire: this.assessmentDetails?.questionnaireguid,
      assessmentUnit: this.assessmentDetails?.assessmentunitguid,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };
    this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log('finally number of questions: ', resp);
      let progressDetails = resp;
      progressDetails.questionnaireProgress = this.assessmentDetails.questionnaireProgress;
      progressDetails.assessmentName = this.assessmentDetails.questionnaireName;
      this.assessmentService.setProgressDetailsData(progressDetails);
      this.route.navigate(['executor-dashboard/progress-tracker-details']);
      const selectedQuestionState = this.storageService.getSessionStorageData('selectedQuestionState');
      if (selectedQuestionState) {
        this.route.navigate(['executor-dashboard/progress-tracker-details'],
          { state: { parent: "submit-assessment", selectedQuestionState: selectedQuestionState } });
      }
      else {
        this.route.navigate(['executor-dashboard/progress-tracker-details']);
      }
    });
  }

  updateQuestionnaireProgress() {
    const rqstBody = {
      assessmentunitguid: this.assessmentDetails.assessmentunitguid,
      quesnaireguid: this.questionaireguid,
      contactguid: this.userDetails.contactguid,
      submitTime: new Date(),
      progress: this.assessmentProgressPercentage,
      questionnaireAccountGuid: this.questionnaireAccountGuid,
      isResubmit: this.isResubmit,
      isChecker: this.isChecker
    }
    this.assessmentService.updateQuestionnaireProgress(rqstBody).subscribe((data: any) => {
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
      if (decryptedData?.isUpdated === true) {
        // if (!this.isResubmit) {
        //   this.storageService.setSessionStorageData('quesStatus', quesStatusVal);
        // }
      }
    });
  }

  ngDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionEvent) {
      this.subscriptionEvent.unsubscribe();
    }
  }

}
